<template>
    <div class="header  animate__animated animate__fadeIn" id="header ">
        <div class="header_con">
            <div class="logo_img" @click="logoClick">
              <img id="header-img" src="../assets/dinghan-logo.png" >
            </div>
            <div class="menu_index" id="menu_index"  >
                <div class="menu-item" v-for="(item,index) in menu" :key="index"    @mouseleave="mouseleave(item.index)">
                    <div class="menu-item-title" @click="handleSelect(item.index)"  @mouseenter="mouseenter(item.index)">
                      <!-- <img v-if="item.index==='5'" src="../../static/other/icon-fee.png" class="img-icon-fee"/> -->
                      <span>{{item.menu}}</span>
                    </div>
                    <div class="submenu animate__animated animate__fadeIn" :class="{'zixun':item.index==5}"  v-if="activeIndex == item.index&&item.index!=1&&item.index!=3&&item.index!=8"  @mouseleave="mouseleave(item.index)">
                       <div class="submenu-item"  @click="goSubMenu(item2.index)"  v-for="(item2,index2) in item.submenu" :key="index2">
                         <img v-if="item2.index==='5-4'" src="../../static/other/icon-fee.png" class="img-icon-fee"/>
                         <img v-else-if="item2.index==='5-6'" class="icon-standard" src="../../static/other/icon-standard.png"/>
                         <!-- <span v-else-if="item2.index.includes('5-')" class="space"></span> -->
                         <span>{{ item2.title }}</span>
                       </div>
                    </div>
                </div>

            </div>
            <div class="opera">
                <div v-if="seen" class="btn" @click="login">立即投保</div>
                <p class="phone">客服电话：400-6399580</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "header",
        data() {
            return {
                activeIndex: '0',
                scroll: '',
                timer: '',
                seen: true,
                currentMenu:'首页',
                sliders: [
                
                ],
                menu:[
                    {menu:'首页',index:'1',submenu:[]},
                    {menu:'产品中心',index:'2',submenu:[
                        {index:'2-1',title:'投标保函'},
                        {index:'2-2',title:'合同履约保函'},
                        {index:'2-3',title:'工程款支付保函'},
                        {index:'2-4',title:'预付款保函'},
                        {index:'2-5',title:'工程质量保函'},
                        {index:'2-6',title:'农民工工资支付保函'},
                    ]},
                    {menu:'合作机构',index:'3',submenu:[]},
                    {menu:'关于我们',index:'4',submenu:[
                        {index:'4-1',title:'公司简介'},
                        {index:'4-2',title:'商务合作'},
                        {index:'4-3',title:'联系我们'},
                        {index:'4-4',title:'诚聘英才'},
                    ]},
                    {menu:'相关资讯',index:'5',submenu:[
                        {index:'5-1',title:'公司动态'},
                        {index:'5-2',title:'政策解读'},
                        {index:'5-3',title:'行业资讯'},
                        // {index:'5-4',title:'干货分享'},
                        {index:'5-5',title:'时事热点'},
                       /* {index:'5-6',title:'收费标准'},*/ // todo
                    ]},
                    {menu:'保函服务',index:'6',submenu:[
                        {index:'6-1',title:'保函查验'},
                        {index:'6-2',title:'理赔申请'}
                    ]},
                    {menu:'信用公示',index:'7',submenu:[
                        {index:'7-1',title:'平台信用公示'},
                        {index:'7-2',title:'查询入口'}
                    ]},
                    {menu:'帮助中心',index:'8',submenu:[]},
                ]
            };
        },
        components:{
         
        },
       
        computed: {
            //计算高度
            computeHeight() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 415) {
                    return '550px';
                } else {
                    return '250px';
                }
            },
            computeArrowImg() {
                let screenHeight = document.body.clientWidth;
                if (screenHeight > 450) {
                    return require('../../static/other/arrow.png');
                } else {
                    return require('../../static/other/arrow_down.png');
                }
            }

        },
        methods: {
            handleSelect(key) {
                switch (key){
                    case '1':
                        this.$router.push({path: "/pc"});
                        break;
                    case '2':
                        this.$router.push({path: "/pc/produce",query:{tabIndex:1}});
                        break;
                    case '3':
                        this.$router.push({path: "/pc/partner"});
                        break;
                    case '4':
                        this.$router.push({path: "/pc/about",query:{tabIndex:1}});
                        break;

                    case '5':
                        this.$router.push({path: "/pc/news",query:{tabIndex:1}});
                        break;
                    case '6':
                        this.$router.push({path: "/pc/service",query:{tabIndex:1}});
                        break;    
                    case '7':
                        this.$router.push({path: "/pc/credit",query:{tabIndex:1}});
                        break;
                    case '8':
                      this.$router.push({path: "/pc/helpCenter",query:{tabIndex:1}});
                      break;
                }
            },
            // handleSelectMobile(key) {
            //     switch (key){
            //         case '1':
            //             this.$router.push({name: "Index"});
            //             this.currentMenu='首页';
            //             break;
            //         case '2-1':
            //             this.$router.push({name: "Index"});
            //             window.location.hash = "#产品微观";
            //             this.currentMenu='首页';
            //             break;
            //         case '2-2':
            //             this.$router.push({name: "Fruit"});
            //             this.currentMenu='生鲜果蔬';
            //             break;
            //         case '2-3':
            //             this.$router.push({name: "Fashion"});
            //             break;
            //         case '3':
            //             this.$router.push({name: "Index"});
            //             window.location.hash = "#产品特点";
            //             this.currentMenu='首页';
            //             break;
            //         case '4':
            //             this.$router.push({name: "Index"});
            //             window.location.hash = "#合作伙伴";
            //             this.currentMenu='首页';
            //             break;
            //         case '5':
            //             this.$router.push({name: "Index"});
            //             window.location.hash = "#关于我们";
            //             this.currentMenu='首页';
            //             break;
            //     }
            // },
            // handleScroll(){
            //     this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
            //     if( this.scroll >600 ){  //判断滚动后高度超过400px,就显示
            //         this.$refs.btn.style.display = 'block';
            //     }else{
            //         this.$refs.btn.style.display = 'none'
            //     }
            // },
            backTop(){ //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
                this.timer = setInterval(() => {
                    let osTop = document.documentElement.scrollTop || document.body.scrollTop;
                    let ispeed = Math.floor(-osTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
                    if (osTop === 0) {
                        clearInterval(this.timer)
                    }
                }, 30)
            },
            login(){
                window.open('https://tb.dinghanwang.com/login','_blank')

            },
            register(){
                window.open('https://admin.fastice-tech.com/registe')
            },
            menuSeen(){
                // 屏幕尺寸
                let screenHeight=document.body.clientWidth;
                if(screenHeight>415){
                    this.seen=true;
                }else{
                    this.seen=false;
                }
            },
            logoClick(){
                this.$router.push({name: "Index"});
                this.currentMenu='首页';
            },
            mouseenter(index){
                if(index != '1'||index != '3'){
                    this.activeIndex = index
                }else{
                this.activeIndex = '0'
                }
            },
            mouseleave(){
                this.activeIndex = '0'
            },
            goSubMenu(key){
                let tabIndex;
                let index = key.indexOf('-');
                let menuIndex ;
                if(index!=-1){
                    tabIndex = key.slice(index+1)
                    menuIndex =key.slice(0,index) ;
                }else{
                    tabIndex = ''
                    menuIndex = key;
                }
                this.$forceUpdate()
                switch (menuIndex){
                    case '1':
                        this.$router.push({path: "/"});
                        break;
                    case '2':
                        this.$router.push({path: "/pc/produce",query:{tabIndex:tabIndex}});
                        break;
                    case '3':
                        this.$router.push({path: "/pc/partner",query:{tabIndex:tabIndex}});
                        break;
                    case '4':
                        this.$router.push({path: "/pc/about",query:{tabIndex:tabIndex}});
                        break;
                    case '5':
                        this.$router.push({path: "/pc/news",query:{tabIndex:tabIndex}});
                        break;
                    case '6':
                        this.$router.push({path: "/pc/service",query:{tabIndex:tabIndex}});
                        break;
                    case '7':
                        this.$router.push({path: "/pc/credit",query:{tabIndex:tabIndex}});
                        break;
                }

            }
        },
      
    }
</script>

<style scoped>
  .header{
    width: 100%;
    height: 80px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(255, 255, 255, 1   );
    margin-bottom: 65px;
    box-shadow: 0 2px 8px rgba(0,0,0,.15);
   
  }


  .header_con{
        width:1400px;
        margin: auto;
        height: 100%;
        display: flex;
        align-items: center;
    }
    .logo_img{
      width: 200px;
      cursor: pointer;
      display: flex;
      justify-content: center;
      img{
        width: 85%;
      }
    }
    #back_to_top{
        position: fixed;
        bottom: 50px;
        right: 30px;
        cursor: pointer
    }
    .header-title{
        font-size: 1em;
    }
    .company_name{
        font-weight: normal;
        font-size: 1em;
    }
    .footer_font{
        font-size: 1em;
    }
   
  
    @media screen and (max-device-width: 415px) {
        .logo_img{
            float:left;
            width: auto;
            cursor: pointer;
        }
        #back_to_top{
            position: fixed;
            bottom: 50px;
            right: 5px;
            cursor: pointer
        }
        .footer_font{
            font-size: 0.875em;
        }
        #menu_index{
            float: right;
            width: auto;
            height: 100%
        }
    }
    a{text-decoration: none;}
    a:visited{text-decoration: none;}
    a:hover {text-decoration: none;}
    a:active{text-decoration:none;}
#menu_index{
    
}
.menu_index{
    font-size:18px;
    display: flex;
}
.header_con .opera{
   display: flex;
   align-items: center;
   height: 100%;
   margin-left: auto;
}
.header_con .opera .phone{
  word-break: keep-all;
  word-wrap: normal;
  margin-left: 10px;
}
.menu-item{
   padding: 0 15px;
   white-space: nowrap;
   height: 80px;
   line-height: 80px;
   position: relative;
   cursor: pointer;
}
.menu-item:hover{
  color:rgb(26, 127, 221);
}
.menu-item .menu-item-title{
  display: flex;
  align-items: center;
}
.menu-item .menu-item-title img{
  width: 40px;
  margin-right: 3px;
}
 .submenu{
    background: #ffffff;
    color: #292828;
    font-size: 16px;
    min-width:60px;
    position: absolute;
    top: 60px;
    left:0;
    line-height: 40px;
    border-radius: 0 0 10px 10px;
    box-shadow: 0 2px 8px rgba(0,0,0,.15);
    padding: 10px 20px ;
 }
  /* .submenu.zixun{
    padding-left: 10px;
    padding-right: 30px;
  } */
 .submenu-item{
   display: flex;
   align-items: center;
 }
 .submenu-item img{
   width: 32px;
   margin-right: 3px;
 }
 .submenu-item img.icon-standard{
   height: 26px;
   width: auto;
   margin-left: 5px;
 }
 .submenu-item .space{
    width: 35px;
 }
 .btn{
        width: 100px;
        height: 45px;
        background: rgb(26, 127, 221);
        color: #fff;
        text-align: center;
        line-height: 45px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        cursor: pointer;
    }
</style>
